import React from "react";
import parse from "html-react-parser";
import ssnHeaderHtml from "../SingleSiteNav/header.html";

const parserOptions = {
  replace: (domNode) => {
    if (domNode.name === "link" && typeof document !== "undefined") {
      const domLinkEl = document.createElement("link");
      domLinkEl.rel = domNode.attribs.rel;
      domLinkEl.href = domNode.attribs.href;
      document.head.appendChild(domLinkEl);
      return React.createElement(React.Fragment);
    }
  },
};
const Header = ({ children }) => {
  return parse(ssnHeaderHtml, parserOptions);
};

export default Header;
